import { ImageFormat, ImageType, ProductImageData } from '@telialt/models/src/EshopModel';
import { getProductImageData } from '@telialt/utils/src/eshopUtils';

export const toSmallImage = (images: ProductImageData[]) => {
    const image = getProductImageData(images, ImageType.Primary, ImageFormat.Thumbnail);

    return image?.url ? { url: image.url, alt: image.altText ?? '' } : { url: '', alt: '' };
};
